// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import { styled, useTheme } from "@3778.care/goban";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HomeIcon from "@mui/icons-material/Home";

import {
  FavoriteIconSelect,
  ServiceIcon,
  ServiceIconUnselected,
} from "../../routes/services/components/icons";

const StyledLabel = styled("span")(({ theme: { palette } }) => ({
  color: palette.primary.main,
  fontSize: 14,
}));

export const useGetButtons = ({ isDesktop, pathname }) => {
  const theme = useTheme();
  const isServicesPath = pathname === "/services";
  const isHealthPath = pathname.includes("/health-status");
  const servicePathRegex = new RegExp(/\/services(\/*)([A-z]*)/);
  const healthPathRegex = new RegExp(/\/health-status(\/*)([A-z]*)/);

  const MobileServiceButton = () =>
    isServicesPath ? (
      <ServiceIcon fill={theme.palette.primary.main} />
    ) : (
      <ServiceIconUnselected />
    );
  const MobileHealthButton = () =>
    isHealthPath ? (
      <FavoriteIconSelect fill={theme.palette.primary.main} />
    ) : (
      <FavoriteIcon />
    );
  const healthLabelSelected = <StyledLabel>Sua Saúde</StyledLabel>;
  const getIconIfMobile = (Icon) =>
    !isDesktop ? <Icon fill={theme.palette.primary.main} /> : undefined;

  return [
    {
      label: "Início",
      value: "/home",
      tour: "homeButton",
      icon: getIconIfMobile(HomeIcon),
    },
    {
      label: "Agenda",
      value: "/appointments",
      tour: "appointmentsButton",
      icon: getIconIfMobile(CalendarTodayIcon),
    },
    {
      label: "Serviços",
      value: "/services",
      tour: "servicesButton",
      icon: getIconIfMobile(MobileServiceButton),
      path: isDesktop ? servicePathRegex : undefined,
    },
    {
      label: isHealthPath ? healthLabelSelected : "Sua Saúde",
      value: "/health-status",
      tour: "yourHealthButton",
      icon: getIconIfMobile(MobileHealthButton),
      path: isDesktop ? healthPathRegex : undefined,
    },
  ];
};
